import { Entity } from '@backstage/catalog-model';
import { GITFLIC_ANNOTATION } from '../utils/constants';

export const isGitflicAvailable = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.[GITFLIC_ANNOTATION]);
